module.exports = __webpack_public_path__ + "img/srtzh1.2c696427.png";